<script setup>
import ActionButton from "@/Components/Buttons/Action.vue"
import { ref, watch } from "vue"
import axios from "axios"
import { debounce } from "lodash";
import { useForm } from "@inertiajs/vue3";
import { ComboboxInput, Combobox, ComboboxOptions, ComboboxOption } from "@headlessui/vue"

const props = defineProps({
  callback: {
    required: true,
  },
  close: {
    required: true,
  },
})

const q = ref('')
const results = ref([])

const getSearchResults = (q) => {
  if (q !== '') {
    axios.get(route('hq.categories.algolia.search'), {
      params: {
        search: q,
      }
    }).then((res) => {
      results.value = res.data
    })
  }
}


const debouncedSearch = debounce(getSearchResults, 250)
watch(q, debouncedSearch)

const attachCategoryForm = useForm({
  category: null,
})

watch(() => attachCategoryForm.category, (category) => addCategory(category))

const addCategory = (category) => {
  props.callback(category)
}
</script>

<template>
  <vue-final-modal
    classes="flex justify-center items-start modal-overflow bg-black bg-opacity-25"
    content-class="relative flex flex-col h-auto mx-auto border dark:border-gray-800 bg-white rounded-lg shadow-lg modal-overflow"
  >
    <div class="absolute w-80 -left-40 top-1.5 p-4 bg-white shadow-md rounded space-y-4 z-50">
      <div class="mt-4">
        <label for="searchCategories">
          {{ __('Search categories') }}
        </label>
        <div class="">
          <div class="relative">
            <Combobox v-model="attachCategoryForm.category">
              <div class="relative mt-1">
                <ComboboxInput
                  class="w-full rounded-md border bg-white py-2 pl-3 pr-10 shadow-sm focus:border-primary-300 focus:ring-primary-200/50 sm:text-sm"
                  @change="q = $event.target.value"
                />
              </div>
              <ComboboxOptions
                v-if="results.length > 0"
                class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
              >
                <ComboboxOption
                  v-for="option in results"
                  :key="option.id"
                  v-slot="{ active, selected }"
                  :value="option"
                  as="template"
                >
                  <li
                    :class="[
                      'relative cursor-default select-none py-2 pl-3 pr-9',
                      active ? 'bg-primary-600 text-white' : 'text-gray-900',
                    ]"
                  >
                    <span :class="['block truncate', selected && 'font-semibold']">
                      {{ option.name }}
                    </span>
                  </li>
                </ComboboxOption>
              </ComboboxOptions>
            </Combobox>
          </div>
        </div>
        <div class="text-xs mt-2 text-gray-500">
          <p>Enter input to search categories</p>
        </div>
      </div>
      <ActionButton @click.prevent="close">{{ __('Close') }}</ActionButton>
    </div>
  </vue-final-modal>
</template>
